import React from 'react';
import './TeamSingle.css';

import { PageTitle } from '../../../components';

import { FaFacebookF, FaInstagram, FaLinkedin, FaEnvelope, FaPhoneAlt } from 'react-icons/fa';
import { FaMapLocationDot, FaXTwitter } from 'react-icons/fa6';

import { useLocation } from 'react-router-dom';



const TeamSingle = () => {

  const location = useLocation();
  const team = location.state;

  const accounts = team.accounts;
  const contacts = team.contacts
  const skills = team.skills;

  const middleIndex = Math.ceil(skills.length / 2);
  const firstColumn = skills.slice(0, middleIndex);
  const secondColumn = skills.slice(middleIndex);

  return (
    <>

      {/* Page title */}
      <PageTitle title={team.name} page={'team single'} />

      <section className='team-single'>

        {/* Team Member Introduction */}
        <div className='team-intro'>

          {/* Team Member Image */}
          <div className='image'>
            <img src={team.image} alt={team.name} />
          </div>

          {/* Team Member Details */}
          <div className='information'>

            <h3>{team.name}</h3> {/* Team Member Name */}
            <h5>{team.title}</h5> {/* Team Member Title */}

            {/* Team Member About */}
            <div className='team-about'>
              <div className='text'>{team.intro}</div> {/* Team Member Biography */}
            </div>

            <ul className="team-personal-info">
              <li> 
                <div className='title'>
                  <div className='icon'><FaPhoneAlt /></div>
                  <h6>Phone:</h6>
                </div> 
                <span>{contacts.phone}</span>
              </li>
              <li> 
                <div className='title'>
                  <div className='icon'><FaEnvelope /></div>
                  <h6>Email:</h6>
                </div> 
                <span>{contacts.email}</span>
              </li>
              <li> 
                <div className='title'>
                  <div className='icon'><FaMapLocationDot /></div>
                  <h6>address:</h6>
                </div>
                <span>{contacts.address}</span>
              </li>
            </ul>

            {/* Social media icons */}
            <div className='icon-container'>
              <a className='icon' href={accounts.facebook}><FaFacebookF /></a> {/* Facebook Icon */}
              <a className='icon' href={accounts.linkedin}><FaLinkedin /></a> {/* LinkedIn Icon */}
              <a className='icon' href={accounts.twitter}><FaXTwitter /></a> {/* Twitter Icon */}
              <a className='icon' href={accounts.instagram}><FaInstagram /></a> {/* Instagram Icon */}
            </div>

          </div>

        </div>

        <div className='box-container page-info'>

          {/* Team Experience */}
          <div className='team-biography sub-section'>
            <h4>Biography</h4>
            <p className='text'>{team.biography}</p>
          </div>

          {/* Professional Skills */}
          <div className='team-skills sub-section'>

            <h4>Professional Skills</h4>

            <div className='skills two-columns'>

              {/* First Column */}
              <div className='skill-column'>
                {firstColumn.map(skill => (
                  <div className='box' key={skill.id}>
                    <h3>{skill.title}<span> {skill.progress}% </span></h3>
                    <div className='progress-bar'>
                      <span style={{ width: `${skill.progress}%` }}></span>
                    </div>
                  </div>
                ))}
              </div>

              {/* Second Column */}
              <div className='skill-column'>
                {secondColumn.map(skill => (
                  <div className='box' key={skill.id}>
                    <h3>{skill.title}<span> {skill.progress}% </span></h3>
                    <div className='progress-bar'>
                      <span style={{ width: `${skill.progress}%` }}></span>
                    </div>
                  </div>
                ))}
              </div>

            </div>

          </div>

        </div>

      </section>
    </>
  )

}

export default TeamSingle;